export const CREATE_PROJECTNEEDS_REQUEST = 'CREATE_PROJECTNEEDS_REQUEST';
export const CREATE_PROJECTNEEDS_SUCCESS = 'CREATE_PROJECTNEEDS_SUCCESS';
export const CREATE_PROJECTNEEDS_FAILURE = 'CREATE_PROJECTNEEDS_FAILURE';

export const FETCH_PROJECTNEEDS_REQUEST = 'FETCH_PROJECTNEEDS_REQUEST';
export const FETCH_PROJECTNEEDS_SUCCESS = 'FETCH_PROJECTNEEDS_SUCCESS';
export const FETCH_PROJECTNEEDS_FAILURE = 'FETCH_PROJECTNEEDS_FAILURE';